import {
  Box,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AutoCompleteList from "components/AutoCompleteList";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPaymentTypesThunk } from "store/reducers/payments";

const PaymentPanel = ({ filter, setFilter }) => {
  const payments = useSelector((state) => state.payments.paymentTypes);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPaymentTypesThunk());
  }, [dispatch]);
  // const [payment, setPayment] = useState(null);
  // const [minPrice, setMinPrice] = useState("");
  // const [maxPrice, setMaxPrice] = useState("");
  // const [price, setPrice] = useState("");
  const setPayment = (value) => {
    setFilter({ ...filter, payment: value });
  };
  return (
    <Box>
      <Stack direction="column" spacing={1.5}>
        <AutoCompleteList
          items={payments}
          name="name"
          label="Select payment type"
          setValue={setPayment}
          value={filter.payment}
        />
        <TextField
          label="Price"
          value={filter.grant_total}
          onChange={(e) =>
            setFilter({ ...filter, grant_total: e.target.value })
          }
          type="number"
          InputProps={{
            startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            inputProps: {
              min: 1,
            },
          }}
        />
        <Stack direction="row" justifyContent="center">
          <Typography>OR</Typography>
        </Stack>

        <TextField
          label="Min price"
          value={filter.grant_total__gt}
          onChange={(e) =>
            setFilter({ ...filter, grant_total__gt: e.target.value })
          }
          type="number"
          InputProps={{
            startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            inputProps: {
              min: 1,
            },
          }}
        />
        <TextField
          label="Max price"
          value={filter.grant_total__lt}
          onChange={(e) =>
            setFilter({ ...filter, grant_total__lt: e.target.value })
          }
          type="number"
          InputProps={{
            startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            inputProps: { min: 1 },
          }}
        />
      </Stack>
    </Box>
  );
};

export default PaymentPanel;
